import {BDShared} from '@brother-apps/brother-dealerapp-shared-lib';
import {ContractTypeEnum} from '../../modules/print-smart/models/contract.model';
import {CredentialsManager} from '../../core/services/credentils.manager';
import {Injectable} from '@angular/core';
import {UserContextService} from '../../core/services/user-context.service';
import {environment} from '../../../environments/environment';
import {HttpServiceBase} from '../../core/services/http-service-base';

@Injectable({providedIn: 'root'} )
export class UtilityService extends HttpServiceBase{

    private downloadServerAddress = '';

    private mpsSampleReportUrl = '/contractTemplates/mps-template';
    private mpsMultiSampleReportUrl = '/contractTemplates/mps-multiple-template';
    private deviceListUrl = '/contractTemplates/device-list-template';

    public constructor(
        private userContextService: UserContextService,
        private credentialsManager: CredentialsManager
    ) {
        super();
        this.downloadServerAddress = this.serverAddress;
        if (this.downloadServerAddress.endsWith('/api')) {
            this.downloadServerAddress = this.downloadServerAddress.substring(0, this.downloadServerAddress.length - 4);
        }

        this.mpsSampleReportUrl = this.downloadServerAddress + this.mpsSampleReportUrl;
        this.mpsMultiSampleReportUrl = this.downloadServerAddress + this.mpsMultiSampleReportUrl;
        this.deviceListUrl = this.downloadServerAddress + this.deviceListUrl;


    }

    public downloadReportTemplate(type: ContractTypeEnum): void {
        this.download(this.mpsSampleReportUrl);
    }

    public downloadMultipleReportTemplate(type: ContractTypeEnum): void {
        this.download(this.mpsMultiSampleReportUrl);
    }

    public downloadDeviceListTemplate(): void {
        this.download(this.deviceListUrl);
    }

    // loads file from url and downloads it
    public download(relativeUrl: string): void {
        const element = document.createElement('a');
        console.log(relativeUrl);
        element.setAttribute('href', relativeUrl);
        element.setAttribute('download', '');
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }


    public downloadBase64(base64: string, filename: string): void {
        const blob = this.b64toBlob(base64, 'application/pdf');
        const data = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = data;
        link.download = filename;
        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));

        setTimeout(function () {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
        }, 100);
    }

    public getBase64(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = () => {
                const result = (fileReader.result as string);
                const splitted = result.split(',');
                resolve(splitted.length === 2 ? splitted[1] : result);
            };
            fileReader.onerror = (error) => reject(error);
        });
    }

    public getFile(accept: string): Promise<File> {
        return new Promise<File>((resolve) => {
            const element = document.createElement('input');
            element.setAttribute('type', 'file');
            element.setAttribute('accept', accept);
            element.addEventListener('change', (fileEvent) => {
                const file = (fileEvent.target as HTMLInputElement).files?.[0];
                document.body.removeChild(element);
                resolve(file);
            });
            element.style.display = 'none';
            document.body.appendChild(element);
            element.click();
        });
    }

    public getFileBase64(accept: string): Promise<string> {
        return new Promise(async (resolve) => {
            const fileReader = new FileReader();
            const eventListener = () => {
                const base64 = fileReader.result as string;
                const splitted = base64.split(',');
                fileReader.removeEventListener('load', eventListener);
                resolve(splitted.length === 2 ? splitted[1] : base64);
            };
            fileReader.addEventListener('load', eventListener, false);
            const file = await this.getFile(accept);
            if (!file) {
                resolve('');
                return;
            }
            fileReader.readAsDataURL(file);
        });
    }

    public getUserQueryParamData(): BDShared {
        const userDetails = this.userContextService.getUserDetails();
        console.log('getUserQueryParamData', userDetails);

        return {
            appPortalSecurityToken: this.userContextService.getAppPortalSecurityToken(),
            apiUrl: environment.serverAddress, // 'https://brother-backend-test.minnt.com:8081/api/v1',
            appPortalId: this.userContextService.getUserId(),
            name: userDetails?.lastName,
            firstname: userDetails?.firstName,
            email: userDetails?.email,
            salutation: userDetails?.salutation,
            relatedContactEmail: this.userContextService.getRelatedContactEmail(),
            itScopeLoggedIn: this.credentialsManager.hasCredential(CredentialsManager.PROVIDER_ITSCOPE, true),
            authorizationGroups: null // todo remove in future, this is not used anymore, but currently is still used in products module, products are hidden and will be removed in future
        } as BDShared;
    }



    public b64toBlob(b64Data: any, contentType = '', sliceSize = 512): any {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        return new Blob(byteArrays, {type: contentType});
    }

    public openPdfInNewTab(pdfB64Content: string, fileName: string): void {
        const blob = this.b64toBlob(pdfB64Content, 'application/pdf');
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.target = '_blank';
        a.click();
    }
}
